import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { standardGrid } from '../../../common/main-layout/styles';
export const cabinBaggagePostbookingStyles = () => {
  const cabinBaggageProductLayoutStyle = readMoreContent => css`
    ${standardGrid}

    .cta {
      grid-area: ${readMoreContent ? '4 / 2 / 5 / 3' : '3 / 2 / 5 / 3'};
    }
  `;
  const cabinBaggageBodyGridLayoutStyle = css`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);

    .description {
      grid-area: 1 / 1 / 2 / 4;
      margin-bottom: 16px;
    }

    .additionalInformation {
      grid-area: 2 / 1 / 3 / 4;
      margin-bottom: 16px;
    }

    .promotionalText {
      grid-area: 5 / 1 / 5 / 4;
      margin-top: 16px;
    }
  `;
  const cabinBaggageCtaGridLayoutStyle = css`
    column-gap: 8px;
    display: grid;
    grid-template-columns: 2fr auto;
    grid-template-rows: repeat(3, auto);

    @media (min-width: ${breakpoints._768}) {
      justify-content: unset;
    }

    .priceLabel {
      grid-area: 4 / 1 / 5 / 4;

      @media (min-width: ${breakpoints._768}) {
        grid-area: 4 / 1 / 4 / 2;
      }
    }

    .price {
      grid-area: 5 / 3 / 6 / 4;
      max-height: 18px;

      @media (min-width: ${breakpoints._768}) {
        grid-area: 5 / 1 / 5 / 2;
      }
    }
  `;
  const weightDescriptionStyles = css`
    grid-area: 3 / 1 / 4 / 4;
    margin-bottom: 4px;

    @media (min-width: ${breakpoints._768}) {
      margin-bottom: 8px;
    }
  `;
  const dimensionGridStyle = css`
    grid-area: 4 / 1 / 5 / 4;
  `;
  const connectedSelectBoxStyles = css`
    display: grid;
    grid-area: 3 / 1 / 4 / 4;

    label {
      margin-inline-start: 0;
    }

    @media (min-width: ${breakpoints._768}) {
      grid-area: 2 / 2 / 6 / 4;
      width: 320px;
    }

    @media (min-width: ${breakpoints._970}) {
      width: 272px;
    }

    @media (min-width: ${breakpoints._1170}) {
      width: 336px;
    }
  `;
  const selectBoxOptionLabelWrapperStyles = css`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
  `;
  const selectBoxOptionLabelTextStyle = css`
    white-space: nowrap;
  `;
  const notificationWrapperStyles = css`
    display: grid;
    grid-area: 5 / 1 / 6 / 4;
    margin-top: 16px;
  `;
  return {
    cabinBaggageProductLayoutStyle,
    cabinBaggageBodyGridLayoutStyle,
    cabinBaggageCtaGridLayoutStyle,
    weightDescriptionStyles,
    dimensionGridStyle,
    connectedSelectBoxStyles,
    selectBoxOptionLabelWrapperStyles,
    selectBoxOptionLabelTextStyle,
    notificationWrapperStyles
  };
};
//# sourceMappingURL=styles.js.map